export default __webpack_public_path__ + "static/media/home_modal_central.48f6b6d7.jpg";